import styles from './OfferCard.module.css';

const OfferCard = ({
    title,
    features,
    details,
    button,
    footer,
    pills,
    testID
}: {
    title: React.ReactNode;
    features: React.ReactNode;
    details: React.ReactNode;
    button?: React.ReactNode;
    pills?: React.ReactNode;
    footer?: React.ReactNode;
    testID?: string;
}) => {
    return (
        <article className={styles.article} data-testid={testID}>
            <div className={styles.panel}>
                <div className={styles.offerHeader}>
                    {pills && <div className={styles.offerPills}>{pills}</div>}
                    {title}
                </div>
                <div className={styles.offerBody}>
                    <div className={styles.offerFeatures}>{features}</div>
                    <div className={styles.offerDetails}>
                        {details}
                        {button && (
                            <div className={styles.offerCTA}>{button}</div>
                        )}
                    </div>
                </div>
                {footer && <div className={styles.offerFooter}>{footer}</div>}
            </div>
        </article>
    );
};

export default OfferCard;
